import { EnableDomainFnReq, EnableDomainFnRes } from '@uploadcam/common';
import { Functions, httpsCallable } from 'firebase/functions';
import { UpdateTeamSettingsInteractor } from './update-team-settings.interactor';

export class EnableDomainInteractor {
  private readonly enableDomainFn = httpsCallable<EnableDomainFnReq, EnableDomainFnRes>(
    this.functions,
    'enableDomain',
  );

  constructor(
    private readonly functions: Functions,
    private readonly updateTeamSettings: UpdateTeamSettingsInteractor,
  ) {}

  public async execute(teamId: string, createDomainUsersDefaultAlbum: boolean): Promise<void> {
    await Promise.all([
      this.enableDomainFn(),
      this.updateTeamSettings.execute(teamId, {
        'app.createDomainUsersDefaultAlbum': createDomainUsersDefaultAlbum,
      }),
    ]);
  }
}
